module.exports = __webpack_public_path__ + "static/media/lineLoginIcon.ad670d6f.png";